import { Typography } from '@mui/material';
import { EmployeeInfoContainer } from './EmployeeInfo.styles';
import { StyledAvatar } from '../StyledAvatar/StyledAvatar';

const EmployeeInfo = ({ employee, headerType }) => {
  return (
    <EmployeeInfoContainer>
      <Typography variant="h4">
        {headerType === 'shift' && (employee.employee.shiftTypes?.[0] || 'Unassigned')}
        {headerType === 'name' && employee.displayName}
      </Typography>
      <StyledAvatar size="large" alt={employee.displayName} src={employee.profileImageUrl} />

      {headerType === 'shift' && <Typography variant="h6">{employee.displayName}</Typography>}

      <Typography variant="subtitle1">{employee.shiftTypes?.join(', ')}</Typography>
    </EmployeeInfoContainer>
  );
};

export default EmployeeInfo;
